import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setPoFilterCriteria } from 'store/slice/PharmaSlice';

export default function PoFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.poDashboard);
    
    
const updatePodateCriteria = (podate) =>{
        dispatch(setPoFilterCriteria(
            {
                ...filterCriteria,
                podate:podate
        }))
    }
const updatePartynameCriteria = (partyname) =>{
        dispatch(setPoFilterCriteria(
            {
                ...filterCriteria,
                partyname:partyname
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Podate"
                            name="podate"
                            value={filterCriteria.podate}
                            onChange={(e)=>updatePodateCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Partyname"
                            name="partyname"
                            value={filterCriteria.partyname}
                            onChange={(e)=>updatePartynameCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>


        </Grid>
    )

}